// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"BE-z","smallCardRow":"CE-z","largeCardRow":"DE-z","productSearchRow":"EE-z","curatedRow":"FE-z"};